
import { CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Newspaper } from "lucide-react";

interface NewsAlertsHeaderProps {
  alertsCount: number;
}

export const NewsAlertsHeader: React.FC<NewsAlertsHeaderProps> = ({ alertsCount }) => {
  return (
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Newspaper className="h-5 w-5" />
        News Intelligence
        <Badge variant="secondary" className="ml-2">
          {alertsCount} alerts
        </Badge>
      </CardTitle>
    </CardHeader>
  );
};
